import { useAxios } from "./useAxios"
import { Pagination } from "@/interfaces/Pagination"
import { PaymentPlanTypeEnum } from "@/enums/payment-plans/PaymentPlanTypeEnum"
import { PaymentPlanStatusEnum } from "@/enums/payment-plans/PaymentPlanStatusEnum"
import { PaymentPlan } from "@/interfaces/PaymentPlan"
import { useBot } from "./useBot"

const axios = useAxios()

export interface CreatePaymentPlanDTO {
  name: string
  type: PaymentPlanTypeEnum
  amount: number
  paymentApprovedMessage: string
  buttonMessage: string
  upsellMessage?: string
  upsellPaymentPlanIds?: number[]
  upsellButtonIds?: number[]
  productId?: number
  variantUUID?: string
  checkoutButtonLabel?: string
  cycle?: number
  orderBumpIds?: number[]
  videoCallIds?: number[]
}

export interface UpdatePaymentPlanDTO {
  name?: string
  type?: PaymentPlanTypeEnum
  amount?: number
  paymentApprovedMessage?: string
  buttonMessage?: string
  upsellMessage?: string
  productId?: number
  variantUUID?: string
  status?: PaymentPlanStatusEnum
  cycle?: number
  upsellPaymentPlanIds?: number[] 
  upsellButtonIds?: number[]
  orderBumpIds?: number[]
  videoCallIds?: number[]
}

export interface GetAllPaymentPlansParams {
  search?: string
  type?: PaymentPlanTypeEnum
  page?: string
  perPage?: string
  whereHasGroupOrPackage?: boolean
  withGroupsAndPackages?: boolean
  withDownsells?: boolean
  withVideoCalls?: boolean
  orderBy?: string
}


export function usePaymentPlan() {
  const { selectedBot } = useBot()

  const create = async (payload: CreatePaymentPlanDTO, callback: () => void) => {
    for (const key in payload) {
      if (!payload[key as keyof typeof payload]) {
        delete payload[key as keyof typeof payload]
      }
    }

    await axios.post('/bots/' + selectedBot.value?.id + '/payment-plans', payload)

    callback()
  }

  const update = async (id: number, payload: UpdatePaymentPlanDTO) => {
    await axios.patch(`/bots/${selectedBot.value?.id}/payment-plans/${id}`, payload)
  }

  const destroy = async (id: number, callback: () => void) => {
    await axios.delete(`/bots/${selectedBot.value?.id}/payment-plans/${id}`)

    callback()
  }

  const getById = async (id: number): Promise<PaymentPlan> => {
    const response = await axios.get(`/bots/${selectedBot.value?.id}/payment-plans/${id}`)

    return response.data
  }

  const getAll = async (params?: GetAllPaymentPlansParams): Promise<Pagination<PaymentPlan>> => {
    if (params) {
      params = Object.fromEntries(
        Object.entries(params).filter(([param, value]) => !!value)
      )
    }

    const response = await axios.get(`/bots/${selectedBot.value?.id}/payment-plans`, { params })

    return response.data
  }

  return {
    create,
    update,
    getById,
    getAll,
    destroy
  }
}